import React, { FC, useEffect, useMemo, useRef, useState } from 'react';
import { Space, Spin, Table, Tag, Typography } from 'antd';
import { WebUxPage, WebUxPageContent, WebUxPageItem } from '../../webux-layouts/WebUxPage';
import { ArrayParam, useQueryParam } from 'use-query-params';
import { useConnection, useUserInfo } from '../../../../connection/Application';
import { PerformanceCycle } from '../../../../entity/PerformanceCycle';
import { FlexBox } from '../../../../components/atoms/FlexBox';
import MultipleToggle from '../../../../components/atoms/MultipleToggle';
import { UserAvatar } from '../../../../components/atoms/UserAvatar';
import Link from 'antd/lib/typography/Link';
import { ClockCircleOutlined } from '@ant-design/icons';
import { fullMark } from './PerformanceResultsPage';
import { useHistory } from 'react-router-dom';
import { PageHeader } from '@ant-design/pro-layout';

const { Text } = Typography;

type teamType = { id: number; name: string; color: string };
type duration = { id: number; from: string; to: string; goalSummeryId: number };
type result = {
  approved?: number;
  pending?: number;
  answer?: number | string;
  percentage?: number;
};

type team = {
  cyclePercentage: number;
  duration: duration[];
  goalHolderId: number;
  internalCustomers?: result;
  lead: boolean;
  peerReviews?: result;
  supervisorFeedBack?: result;
  teamId: number;
  teamImage: string;
  teamName: string;
  teamPerformance?: result;
};

type subordinate = {
  userId: number;
  name: string;
  cycleClose: boolean;
  goalSummaryId: number;
  image: string;
  teams: team[];
};

type subordinateTeam = {
  teamId: number;
  lead: boolean;
  teamImage: string;
  goalHolderId: number;
  subordinate: subordinate[];
  teamName: string;
  teamType: teamType;
};

type response = {
  cycleDuration: number;
  subordinateTeams: subordinateTeam[];
  teams: team[];
};

export const MainPerformanceResultsPage: FC = () => {
  const [teams, setTeams] = useState<any[]>([]);
  const [subordinateTeams, setSubordinateTeams] = useState<any[]>([]);
  const [expanded, setExpanded] = useQueryParam('e', ArrayParam);
  const [cycles, setCycles] = useState<PerformanceCycle[]>([]);
  const [cycle, setCycle] = useQueryParam('cycle', ArrayParam);
  const cycleRef = useRef(cycle);
  const user = useUserInfo();
  const history1 = useHistory();

  const columns = useMemo(() => {
    return [
      {
        title: 'Performance',
        dataIndex: 'title',
        key: 'title',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) =>
          record.itemType ? (
            <div>
              {/*<Tooltip placement="top" title={`Go to ${text} Performance Result`}>*/}
              <Space>
                <UserAvatar type={record.itemType} src={record.image} />
                <Link
                  onClick={() => {
                    history1.push(
                      `/webux/dashboard/${record.userId}?${cycle
                        ?.map((n) => `cycle=${n}`)
                        .reduce((x, y) => x + y, '')}`,
                    );
                  }}>
                  {text}
                </Link>
              </Space>
              {/*</Tooltip>*/}
            </div>
          ) : (
            <Text strong>{text}</Text>
          ),
      },
      {
        title: 'Results Status',
        dataIndex: 'closure',
        key: 'cycleClose',
        width: '150px',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) => {
          if (record.cycleClose === true) {
            return (
              <Tag style={{ height: 25 }} color="green">
                Published
              </Tag>
              // <Button
              //   type="primary"
              //   icon={<PoweroffOutlined />}
              //   size="small"
              //   onClick={() =>
              //     prePublish(record?.goalSummaryId ?? 0, record?.teamId ?? 0, record.title)
              //   }>
              //   Publish Results
              // </Button>
            );
          } else if (record.cycleClose === false) {
            return <Tag style={{ height: 25 }}>Not Published</Tag>;
          } else {
            return record.itemType ? (
              record?.teams?.find(
                (y: {
                  supervisorFeedBack: { answer: any };
                  peerReviews: { answer: any };
                  internalCustomers: { answer: any };
                  teamPerformance: { answer: any };
                }) =>
                  typeof y.supervisorFeedBack?.answer === 'string' ||
                  typeof y.peerReviews?.answer === 'string' ||
                  typeof y.internalCustomers?.answer === 'string' ||
                  typeof y.teamPerformance?.answer === 'string',
              ) ? (
                <Tag style={{ height: 25 }}>Not Published</Tag>
              ) : (
                <Tag style={{ height: 25 }} color="green">
                  Published
                </Tag>
              )
            ) : (
              <></>
            );
          }
        },
      },
      {
        title: 'Score',
        dataIndex: 'completed',
        key: 'completed',
        // eslint-disable-next-line react/display-name
        render: (text: string, record: any) =>
          record.teams &&
          record.teams.length !== 0 && (
            <Typography.Title level={5}>
              {record?.teams?.find(
                (y: {
                  supervisorFeedBack: { answer: any };
                  peerReviews: { answer: any };
                  internalCustomers: { answer: any };
                  teamPerformance: { answer: any };
                }) =>
                  typeof y.supervisorFeedBack?.answer === 'string' ||
                  typeof y.peerReviews?.answer === 'string' ||
                  typeof y.internalCustomers?.answer === 'string' ||
                  typeof y.teamPerformance?.answer === 'string',
              ) ? (
                <Tag icon={<ClockCircleOutlined />} color="default">
                  Pending
                </Tag>
              ) : (
                `${fullMark(record?.teams).toFixed(2)}%`
              )}
            </Typography.Title>
          ),
        width: '200px',
      },
    ];
    // eslint-disable-next-line
  }, [cycle, history1]);
  const [loading, setLoading] = useState<boolean>(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading1, setLoading1] = useState<boolean>(false);

  const connection = useConnection();

  useEffect(() => {
    const token = connection.hasSession();
    if (token) {
      setLoading(true);
      connection
        .get<{ performanceCycle: PerformanceCycle[]; closestCycle: PerformanceCycle }>('cycles')
        .then((value) => {
          setCycles(value.performanceCycle);
          if (cycleRef.current === undefined) {
            setCycle([value.closestCycle.id + ''], 'replace');
          }
        })
        .catch(() => setLoading(false));
    }
  }, [connection, setCycle]);

  useEffect(() => {
    if (cycle) {
      setLoading(true);
      connection
        .get(`users/overall-score/cycle?cycle=${cycle}`)
        .then((res: { response: response }) => {
          setTeams(res.response.teams);
          setSubordinateTeams(res.response.subordinateTeams);
        })
        .catch(() => setLoading(false))
        .finally(() =>
          setTimeout(() => {
            setLoading(false);
          }, 600),
        );
    }
  }, [connection, cycle, user?.userId, loading1]);

  const tableData = useMemo(() => {
    if (teams.length === 0 && subordinateTeams.length === 0) {
      return [];
    }
    const tdt: any = [];
    let i = -6;
    let j = 0;
    if (teams.length !== 0) {
      tdt.push({
        key: -4,
        title: `My Performance Result`,
        link: '#',
        children: [
          {
            image: user?.image,
            title: user?.fullName,
            key: j++,
            type: 'Self',
            userId: user?.userId,
            color: 'gold',
            itemType: 'user',
            teams: teams,
            completed: 0,
          },
        ],
      });
    }
    subordinateTeams.forEach((e) => {
      tdt.push({
        key: i--,
        title: `${e.teamName} subordinate Performance Result`,
        link: '#',
        children: e.subordinate
          .sort((a: subordinate, b: subordinate) => a.userId - b.userId)
          .map((e1: any) => ({
            image: e1?.image,
            title: e1?.name,
            key: j++,
            userId: e1?.userId,
            cycleClose: e1?.cycleClose,
            goalSummaryId: e1?.goalSummaryId,
            teamId: e?.teamId,
            type: 'Employ',
            color: 'gold',
            itemType: 'user',
            teams: e1.teams,
            completed: 0,
          })),
      });
    });
    return tdt;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subordinateTeams, teams, user?.fullName, user?.image]);

  return (
    <WebUxPage>
      <PageHeader
        ghost={false}
        style={{ background: '#FFF' }}
        title="Performance Results"
        subTitle="Manage performance result details"
      />
      <WebUxPageContent>
        <WebUxPageItem>
          <FlexBox>
            {/*<CycleToggle*/}
            {/*  value={parseInt(`${cycle}`)}*/}
            {/*  onChange={(value) => setCycle(value, 'replace')}*/}
            {/*  data={cycles}*/}
            {/*/>*/}
            <MultipleToggle
              value={cycle?.map((e) => parseInt(`${e}`)) ?? []}
              data={cycles}
              onChange={(value) =>
                setCycle(
                  value?.map((e) => e + ''),
                  'replace',
                )
              }
            />
          </FlexBox>

          <Spin spinning={loading}>
            <Table
              size="small"
              columns={columns}
              dataSource={tableData}
              expandable={{ indentSize: 0 }}
              expandedRowKeys={
                expanded
                  ? (expanded as any)
                      .map((x: any) => parseInt(x, 10))
                      .filter((f: number) => f !== -5)
                  : [-1, -2, -3, -4, -6, -7, -8, -9, -10, -11, -12, -13, -14]
              }
              onExpandedRowsChange={(expanded: any) => {
                setExpanded(expanded.length === 0 ? -5 : expanded, 'replaceIn');
              }}
              pagination={false}
            />
          </Spin>
        </WebUxPageItem>
      </WebUxPageContent>
    </WebUxPage>
  );
};
